import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import {
    AdicionarAlcadaDescontoController,
    AtualizarAlcadaDescontoController,
} from "../../../Controllers/Cobranca/AlcadaDesconto/AlcadaDescontoController";
import {
    ConsultarEmpresaController,
    ConsultarObraController,
} from "../../../Controllers/Cobranca/Obras/ObrasController";
import { ListarGruposController } from "../../../Controllers/Geral/Grupos/GruposController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IAlcadaDescontoPorGrupo } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import UnForm from "../../Form";
import { useUserInfor } from "../../../Context/User";

import Select from "react-select";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import OrSpinner from "../../Utils/OrSpinner";

interface ICadastrarDescontoAlcadaProps {
    updateList: () => void;
    setShow: Dispatch<SetStateAction<boolean>>;
    alcadasDesconto?: IAlcadaDescontoPorGrupo;
}

export default function CadastrarDescontoAlcada(
    props: ICadastrarDescontoAlcadaProps
) {
    const [valorPrincipal, setValorPrincipal] = useState<boolean>(
        props.alcadasDesconto?.FL_VALOR_PRINCIPAL ?? false
    );
    const [idEmpresa, setIdEmpresa] = useState<number>(
        Number(props.alcadasDesconto?.ID_EMPRESA)
    );
    const [idObra, setIdObra] = useState<string>(
        props.alcadasDesconto?.ID_OBRA ?? ""
    );

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const {
        execute: adicionarAlcadaDesconto,
        loading: adicionarAlcadaDescontoLoading,
    } = useAsyncCallback(AdicionarAlcadaDescontoController);

    const {
        execute: atualizarAlcadaDesconto,
        loading: atualizarAlcadaDescontoLoading,
    } = useAsyncCallback(AtualizarAlcadaDescontoController);

    function handleCadastrarAlcada(formData: IAlcadaDescontoPorGrupo) {
        console.log(formData);
        if (props.alcadasDesconto) {
            atualizarAlcadaDesconto({
                ...formData,
                ID_ALCADA_DESCONTO: props.alcadasDesconto.ID_ALCADA_DESCONTO,
                ID_EMPRESA: idEmpresa ?? undefined,
                ID_OBRA: idObra ?? undefined,
            }).then(() => {
                props.updateList();
                props.setShow(false);
            });
        } else {
            adicionarAlcadaDesconto({
                ...formData,
                ID_EMPRESA: idEmpresa ?? undefined,
                ID_OBRA: idObra ?? undefined,
            }).then(() => {
                props.updateList();
                props.setShow(false);
            });
        }
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: empresasOptions, loading: empresasOptionsLoading } =
        useAsyncEffect(() => ConsultarEmpresaController(), []);

    const { value: obrasOptions } = useAsyncEffect(async () => {
        if (idEmpresa || props.alcadasDesconto?.ID_EMPRESA)
            return ConsultarObraController(
                idEmpresa ?? props.alcadasDesconto?.ID_EMPRESA
            );
    }, [idEmpresa, props.alcadasDesconto?.ID_EMPRESA]);

    return (
        <OrSpinner loading={empresasOptionsLoading} spinner="capys">
            <UnForm handleSubmit={handleCadastrarAlcada} className="mb-4">
                <div className="col-12 my-3">
                    <label>Empresa</label>
                    <Select
                        name="ID_EMPRESA"
                        options={empresasOptions?.map((emp) => ({
                            label: emp.DS_EMPRESA,
                            value: emp.ID_EMPRESA,
                        }))}
                        isClearable
                        onChange={(e: any) => {
                            setIdEmpresa(e.value);
                        }}
                        defaultValue={empresasOptions
                            ?.filter(
                                (emp) =>
                                    emp.ID_EMPRESA ===
                                    props.alcadasDesconto?.ID_EMPRESA
                            )
                            .map((emp) => ({
                                label: emp.DS_EMPRESA,
                                value: emp.ID_EMPRESA,
                            }))}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma empresa encontrada."}
                    />
                </div>

                <div className="col-12 my-3">
                    <label>Obra</label>
                    <Select
                        name="ID_OBRA"
                        options={obrasOptions?.map((emp) => ({
                            label: emp.DS_OBRA,
                            value: emp.ID_OBRA,
                        }))}
                        isClearable
                        onChange={(e: any) => {
                            setIdObra(e.value);
                        }}
                        defaultValue={obrasOptions
                            ?.filter(
                                (emp) =>
                                    emp.ID_OBRA.toString() ===
                                    props.alcadasDesconto?.ID_OBRA
                            )
                            .map((emp) => ({
                                label: emp.DS_OBRA,
                                value: emp.ID_OBRA,
                            }))}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma obra encontrada."}
                    />
                </div>

                <div className="col-12 d-flex my-3">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_PERCENTUAL_MULTA
                            }
                            label="Percentual de Multa"
                            type="number"
                            name="NUM_PERCENTUAL_MULTA"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_PERCENTUAL_JUROS
                            }
                            label="Percentual de Juros"
                            type="number"
                            name="NUM_PERCENTUAL_JUROS"
                        />
                    </div>
                </div>

                <div className="col-12 d-flex my-3">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_MINIMO_PARCELAS
                            }
                            label="Número Parcelas Minímo"
                            type="number"
                            name="NUM_MINIMO_PARCELAS"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.LazySelect
                            defaultValue={props.alcadasDesconto?.ID_GRUPO}
                            label="Grupo"
                            controller={ListarGruposController}
                            getDS={(g) => g.DS_GRUPO}
                            getKeyValue={(g) => g.ID_GRUPO}
                            name="ID_GRUPO"
                        >
                            <option />
                        </UnForm.LazySelect>
                    </div>
                </div>

                <div className="col-12 d-flex my-3">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NR_INICIO_AGING
                            }
                            label="Início Inadimplência"
                            type="number"
                            name="NR_INICIO_AGING"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.Input
                            defaultValue={props.alcadasDesconto?.NR_FIM_AGING}
                            label="Final Inadimplência"
                            type="number"
                            name="NR_FIM_AGING"
                        />
                    </div>
                </div>
                {ID_ORGANIZACAO === emccampMode && (
                    <div className="col-12 d-flex my-3">
                        <div className="col-6" style={{ paddingLeft: 0 }}>
                            <UnForm.Switch
                                color="success"
                                label="Valor Principal?"
                                labelPosition="top"
                                name="FL_VALOR_PRINCIPAL"
                                type="checkbox"
                                wrapperClassName="col-12"
                                onChange={(e) =>
                                    setValorPrincipal(e.target.checked)
                                }
                                defaultChecked={
                                    props.alcadasDesconto?.FL_VALOR_PRINCIPAL
                                }
                            />
                        </div>{" "}
                        {valorPrincipal && (
                            <div className="col-6" style={{ paddingRight: 0 }}>
                                <UnForm.Input
                                    defaultValue={
                                        props.alcadasDesconto
                                            ?.NUM_PERCENTUAL_VALOR_PRINCIPAL
                                    }
                                    label="Percentual Valor Principal"
                                    type="number"
                                    name="NUM_PERCENTUAL_VALOR_PRINCIPAL"
                                    wrapperClassName="col-12"
                                    registerOptions={{
                                        required:
                                            "Insira um percentual para o valor principal",
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}

                <UnForm.SubmitButton
                    color="primary"
                    type="submit"
                    wrapperClassName="col-12"
                    className="py-2 w-100"
                    icon={faPlus}
                    loadingSize="sm"
                    loading={
                        adicionarAlcadaDescontoLoading ||
                        atualizarAlcadaDescontoLoading
                    }
                    outline
                >
                    {props.alcadasDesconto
                        ? "Editar Desconto Alçada"
                        : "Cadastrar Desconto Alçada"}
                </UnForm.SubmitButton>
            </UnForm>
        </OrSpinner>
    );
}
